import { Model } from "@vuex-orm/core";
import { required, maxLength } from "vuelidate/lib/validators";

export default class Coating extends Model {
  static entity = 'coatings';

  static $fetch() {
    return this.api().get('Coatings/')
  }
  static $put (id, data) {
    return this.api().put(`Coatings/${id}/`, data)
  }
  static $post (data) {
    return this.api().post(`Coatings/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string("mdi-water"),
      color: this.string("cyan darken-2"),
      label: this.string("Coating Name"),
      counter: this.number(32),
      hint: this.string("Al2O3, TiCl4, etc...")
    };
  }

  toCreatePayload() {
    return {
      name: this.name
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(32) }
      }
    };
  }

  static get errors() {
    return {
      name: {
        required
      }
    };
  }
}

